// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

const mySwipers = new Swiper('.swiper-services-container', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 70,
  lazy: true,
  centeredSlides: true,
  slidesPerView: "auto",
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 300,
  // Navigation arrows
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1052: {
      slidesPerView: 3,
      spaceBetween: 24,
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-services-next',
    prevEl: '.swiper-services-prev',
  },
});

  var news = new Swiper('.swiper-container-bannerHome', {
    loop: true,
    slidesPerView: 1,
    lazy: true,
    centeredSlides: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    // navigation: {
    //     nextEl: '.swiper-news-next',
    //     prevEl: '.swiper-news-prev'
    // }
});